/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Form_Exp_DateInputs */

const vi_aml_form_exp_date = /** @type {(inputs: Aml_Form_Exp_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HSD`)
};

/**

* @param {Aml_Form_Exp_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_form_exp_date = /** @type {((inputs?: Aml_Form_Exp_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Form_Exp_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_form_exp_date(inputs)
});